import { useTranslation } from 'react-i18next';

import {
  EmptyContainer,
  EMPTY_ILLUSTRATIONS,
  Loader,
  ExpandableTable,
  Typography,
  ICONS,
  PLATFORM_THEME_COLORS,
  Icon,
} from '@thinknet-gmbh/platform-common-ui';

import { dateFormat } from 'src/common/helpers/date.helpers';
import { getWorkingConditionActualContract } from '../../employee-details.helpers';
import TableDetailsItem from './table-details-item/table-details-item.component';

import {
  MainTableContainer,
  TableRowContainer,
  TableRowEdit,
} from './working-conditions-table.styles';

import { IWorkingConditionItem } from '../../employee.interfaces';

const WorkingConditionsTable = ({
  collection,
  loading,
  onClickEdit,
  isOwnData,
}: {
  onClickEdit?: (data: IWorkingConditionItem) => void;
  loading?: boolean;
  collection: IWorkingConditionItem[];
  isOwnData?: boolean
}) => {
  const { t } = useTranslation(['common', 'employee', 'settings']);

  if (loading) {
    return <Loader />;
  }

  return (
    <MainTableContainer>
      {collection?.length ? (
        <ExpandableTable
          t={t}
          showHeader={false}
          loading={loading}
          dataSource={collection}
          expandedRowRender={document => <TableDetailsItem workingCondition={document} />}
        >
          <ExpandableTable.Column
            title={t('settings:documentsLabels.labels')}
            key="_id"
            dataIndex="_id"
            render={(_, record: IWorkingConditionItem) => {
              const contract =
                record?.contracts && getWorkingConditionActualContract(record.contracts);
              return (
                <TableRowContainer>
                  <Typography weight="bold">{record?.companyDepartment?.name}</Typography>
                  <Typography>{`${record?.job?.title} | ${
                    contract?.hireDate ? dateFormat(contract?.hireDate) : ''
                  }  ${
                    record?.terminationDate ? `- ${dateFormat(record.terminationDate)}` : ''
                  } `}</Typography>
                  {!isOwnData && (
                    <TableRowEdit
                      {...(onClickEdit && {
                        onClick: () => {
                          onClickEdit(record);
                        },
                      })}
                    >
                      <Icon icon={ICONS.editAlt} color={PLATFORM_THEME_COLORS.primary.blue} />
                      <div>{t('common:buttons.edit')}</div>
                    </TableRowEdit>
                  )}
                </TableRowContainer>
              );
            }}
          />
        </ExpandableTable>
      ) : (
        <EmptyContainer illustration={EMPTY_ILLUSTRATIONS.dataAnalysis} />
      )}
    </MainTableContainer>
  );
};

export default WorkingConditionsTable;
